module.exports = __webpack_public_path__ + "img/img-eat-11.c790dbfe.png";